<template>
  <div class="solution-detail-component">
    <!-- 行业需求部分 -->
    <div class="bjt" >
        <img src="../../../public/img/internet/换电柜.png" alt="">
   </div>

    <!-- 解决方案部分 -->
    <section class="solutions">
      <h2 class="section-title">解决方案</h2>
      <div class="solutions-list">
        <div class="solution-item">
          <div class="icon-placeholder">
            <img
              class="fanganimg"
              src="../../../public/img/internet/solution/icon4-5.png"
              alt=""
            />
          </div>
          <div class="solution-content">
            <h3>工业级4G DTU</h3>
            <p>
              为电池整体通信提供定制化防水防尘DTU，兼容不同协议，适配不同类型的换电设备
            </p>
          </div>
        </div>
        <div class="solution-item">
          <div class="icon-placeholder">
            <img
              class="fanganimg"
              src="../../../public/img/internet/solution/icon4-6.png"
              alt=""
            />
          </div>
          <div class="solution-content">
            <h3>实时数据</h3>
            <p>
              提供三大运营商网络服务，保障设备实时在线，实时回传电池运行数据
            </p>
          </div>
        </div>
        <div class="solution-item">
          <div class="icon-placeholder">
            <img
              class="fanganimg"
              src="../../../public/img/internet/solution/icon4-7.png"
              alt=""
            />
          </div>
          <div class="solution-content">
            <h3>OTA升级</h3>
            <p>支持客户按需进行OTA升级</p>
          </div>
        </div>
        <div class="solution-item">
          <div class="icon-placeholder">
            <img
              class="fanganimg"
              src="../../../public/img/internet/solution/icon4-8.png"
              alt=""
            />
          </div>
          <div class="solution-content">
            <h3>低功耗设计</h3>
            <p>低功耗设计，符合节能环保要求服务成效</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务成效部分 -->
    <section class="service-results">
      <h2 class="section-title">服务成效</h2>
      <div class="results-list">
        <div class="result-item">
          <div class="icon-placeholder">
            <img
              class="fanganimgss"
              src="../../../public/img/internet/solution/icon4-9.png"
              alt=""
            />
          </div>
          <h3>快速响应</h3>
          <p>
            及时故障响应，电池过温、充电异常等问题自动触发工单，响应时间从4小时缩短至10分钟
          </p>
        </div>
        <div class="result-item">
          <div class="icon-placeholder">
            <img
              class="fanganimgss"
              src="../../../public/img/internet/solution/icon4-10.png"
              alt=""
            />
          </div>
          <h3>降本增效</h3>
          <p>
            <span class="spansize">减少90%</span>的人工巡检，单站年均运维成本<span class="spansize">下降60%</span>
          </p>
        </div>
        <div class="result-item">
          <div class="icon-placeholder">
            <img
              class="fanganimgss"
              src="../../../public/img/internet/solution/icon4-11.png"
              alt=""
            />
          </div>
          <h3>多站共享</h3>
          <p>网络运行可靠，多站点共享流量，降低闲置成本</p>
        </div>
        <div class="result-item">
          <div class="icon-placeholder">
            <img
              class="fanganimgss"
              src="../../../public/img/internet/solution/icon4-12.png"
              alt=""
            />
          </div>
          <h3>节能环保</h3>
          <p>低功耗设计，节能环保</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HvacSolution",
  emits: ["close"],
};
</script>

<style lang="scss" scoped>
.bjt{
  // position: relative;
  min-height: 382px;
  img{
    width: 1920px;
    height: 390px;
    position: absolute;
    top: 650px;
    left: 0;
    // object-fit: cover;
  }
}
.solution-detail-component {
  padding: 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.section-title {
  font-size: 40px;
  color: #333;
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  font-family: PingFang SC, PingFang SC-500;
  font-weight: 600;


  &::after {
      content: "";
      display: block;
      width: 80px;
      height: 4px;
      background: linear-gradient(to right, #0C9AFF, #0C45FF);
      margin: 10px auto 0;
    }
}

.industry-demands {
  margin-bottom: 60px;
  background: #fafafa;

  .section-title {
    font-size: 40px;
    color: #333;
    text-align: center;
    margin-bottom: 40px;
    font-weight: 500;

    &::after {
      content: "";
      display: block;
      width: 80px;
      height: 4px;
      background: linear-gradient(to right, #0C9AFF, #0C45FF);
      margin: 10px auto 0;
    }
  }
}

.demands-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  text-align: left;
}

.demand-item {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
 
  position: relative;

  .demand-label {
    font-size: 14px;
    color: #9e9191;
    margin-bottom: 8px;
  }

  h3 {
    font-size: 20px;
    color: #333;
    margin-bottom: 16px;
    font-weight: 500;
  }

  p {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin: 0;
  }

  .icon-placeholder {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 32px;
    height: 32px;
    // background-color: #e6f7ff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

// 解决方案样式
.solutions-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 60px;
}

.solution-item {
  display: flex;
  align-items: center;
  padding: 30px;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: #fafafa;
  border: none;
  &:hover {
    background-color: #f3f6ff;
    border: none;
    .icon-placeholder {
      // background-color: #fff;
    }
    h3 {
      color: #1890ff;
    }
  }

  .icon-placeholder {
    width: 80px;
    height: 80px;
    border-radius: 12px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .solution-content {
    padding-left: 20px;
    flex: 1;
    h3 {
      font-size: 18px;
      color: #333;
      margin-bottom: 10px;
      font-weight: 600;
      font-family: PingFang SC, PingFang SC-500;
    }

    p {
      font-size: 14px;
      color: #666;
      line-height: 1.6;
    }
  }
}

// 服务成效样式
.service-results {
  margin-bottom: 60px;
  margin-top: 120px;
  .section-title {
    font-size: 40px;
    color: #333;
    text-align: center;
    margin-bottom: 40px;
    font-family: PingFang SC, PingFang SC-500;
    font-weight: 600;

    &::after {
      content: "";
      display: block;
      width: 80px;
      height: 4px;
      background: linear-gradient(to right, #0C9AFF, #0C45FF);
      margin: 10px auto 0;
    }
  }
}

.results-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.result-item {
  text-align: center;
  padding: 32px 24px;
  background: #ffffff;
  border-radius: 12px;
   
  transition: all 0.3s ease;
  border: 1px solid transparent;
  border: 1px solid #e5e7eb;
  &:hover {
    /* 移除浮动和阴影效果 */
    /* transform: translateY(-5px); */
    /* box-shadow: 0 12px 24px rgba(24, 144, 255, 0.12); */
    border-color: #1890ff;
    .icon-placeholder {
      // background-color: #E6F7FF;
    }
    h3 {
      color: #1890ff;
      font-family: PingFang SC, PingFang SC-500;
      font-weight: 600;
    }
  }

  .icon-placeholder {
    width: 100px;
    height: 100px;
    margin: 0 auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  h3 {
    font-size: 20px;
    color: #333333;
    margin-bottom: 16px;
    font-weight: 500;
    transition: color 0.3s ease;
    font-family: PingFang SC, PingFang SC-500;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    color: #666666;
    line-height: 1.6;
    margin: 0;
    padding: 0 12px;
  }
}

.fanganimgss {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.icon-placeholders {
  width: 45px;
  height: 45px;
}

.fanganimg {
  width: 83px;
  height: 83px;
}
.solutions {
  margin-top: -70px;
  .solutions-list {
    text-align: left;
  }
}
.spansize {
  color: blue;
}
</style>
